import Nullstack from 'nullstack';
export default function IconStatusChange({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-status-change",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "18",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "18",
    cy: "18",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M6 12v-2a6 6 0 1 1 12 0v2"
  }), "   ", Nullstack.element("path", {
    d: "M15 9l3 3l3 -3"
  }), " ");
}